import ApplicationController from "application_controller.js";

//* Loads the price of the stay picked on the easepick calendar into a turbo
//* frame. Empties the frame while the stay has no departure.
//*
//* <turbo-frame id="price-estimate"
//*   data-controller="price-estimate"
//*   data-action="easepick-handle-select@window->price-estimate#update"
//*   data-price-estimate-url-value="/price_estimate"></turbo-frame>
export default class extends ApplicationController {
  debug = false;

  static values = { url: String };

  update(event) {
    this.log_function("update");

    const { start, end } = event.detail;
    if (start && end) {
      const url = new URL(this.urlValue, window.location.href);
      url.search = new URLSearchParams({ arrival: start.format("YYYY-MM-DD"), departure: end.format("YYYY-MM-DD") });
      this.element.src = url.toString();
    } else {
      this.element.removeAttribute("src");
      this.element.replaceChildren();
    }
  }
}
